import React, { useState } from "react";
import "./WordBuilder1.css";

// Keep only a small sample inline or import from JSON/API
const questions = [
  { clue: "A tropical fruit with spikes", answer: "PINEAPPLE" },
  { clue: "A small red fruit", answer: "CHERRY" },
  { clue: "King of the jungle", answer: "LION" },
  { clue: "Largest land animal", answer: "ELEPHANT" },
  { clue: "It gives light at night", answer: "MOON" },
  { clue: "Planet known as Red Planet", answer: "MARS" },
  { clue: "Fastest land animal", answer: "CHEETAH" },
  { clue: "Bird that cannot fly", answer: "OSTRICH" },
  { clue: "National bird of India", answer: "PEACOCK" },
  { clue: "Tallest animal", answer: "GIRAFFE" },
  { clue: "It swims in the ocean", answer: "DOLPHIN" },
  { clue: "Largest ocean", answer: "PACIFIC" },
  { clue: "It produces honey", answer: "BEE" },
  { clue: "Insect with colorful wings", answer: "BUTTERFLY" },
  { clue: "It barks", answer: "DOG" },
  { clue: "It meows", answer: "CAT" },
  { clue: "It gives milk", answer: "COW" },
  { clue: "It lays eggs", answer: "HEN" },
  { clue: "It roars", answer: "TIGER" },
  { clue: "It hops", answer: "RABBIT" },
  { clue: "It croaks", answer: "FROG" },
  { clue: "It slithers", answer: "SNAKE" },
  { clue: "It has a shell", answer: "TURTLE" },
  { clue: "It pinches with claws", answer: "CRAB" },
  { clue: "It lives in desert", answer: "CAMEL" },
  { clue: "It carries trunk", answer: "ELEPHANT" },
  { clue: "It gives wool", answer: "SHEEP" },
  { clue: "It neighs", answer: "HORSE" },
  { clue: "It swims upstream", answer: "SALMON" },
  { clue: "It has black and white stripes", answer: "ZEBRA" },
  { clue: "It is man's best friend", answer: "DOG" },
  { clue: "It guards the house", answer: "DOG" },
  { clue: "It is used to write", answer: "PEN" },
  { clue: "It is used to erase", answer: "ERASER" },
  { clue: "It is used to cut paper", answer: "SCISSORS" },
  { clue: "It is used to measure time", answer: "CLOCK" },
  { clue: "It is used to tell date", answer: "CALENDAR" },
  { clue: "It is used to store water", answer: "BOTTLE" },
  { clue: "It is used to eat food", answer: "SPOON" },
  { clue: "It is used to cook rice", answer: "POT" },
  { clue: "It is used to sweep floor", answer: "BROOM" },
  { clue: "It is used to wash clothes", answer: "SOAP" },
  { clue: "It is used to clean teeth", answer: "BRUSH" },
  { clue: "It is used to wear on feet", answer: "SHOES" },
  { clue: "It is worn on head", answer: "CAP" },
  { clue: "It is worn on hand", answer: "GLOVE" },
  { clue: "It is worn to see clearly", answer: "GLASSES" },
  { clue: "It is worn to tell time", answer: "WATCH" },
  { clue: "It is worn to protect from rain", answer: "RAINCOAT" },

  { clue: "A yellow fruit", answer: "BANANA" },
  { clue: "A red fruit", answer: "APPLE" },
  { clue: "It flies in space", answer: "ROCKET" },



  
  { clue: "Capital of France", answer: "PARIS" },
  { clue: "Largest planet in solar system", answer: "JUPITER" },
  { clue: "Inventor of the light bulb", answer: "EDISON" },
  { clue: "Greek god of the sea", answer: "POSEIDON" },
  { clue: "Metal that is liquid at room temperature", answer: "MERCURY" },
  { clue: "Fastest bird", answer: "FALCON" },
  { clue: "Author of Hamlet", answer: "SHAKESPEARE" },
  { clue: "Tallest mountain", answer: "EVEREST" },
  { clue: "River flowing through Egypt", answer: "NILE" },
  { clue: "Hardest natural substance", answer: "DIAMOND" },
  { clue: "First man on the moon", answer: "ARMSTRONG" },
  { clue: "Largest desert", answer: "SAHARA" },
  { clue: "Currency of Japan", answer: "YEN" },
  { clue: "Chemical symbol for gold", answer: "AU" },
  { clue: "Smallest prime number", answer: "TWO" },
  { clue: "National sport of Canada", answer: "HOCKEY" },
  { clue: "Instrument with six strings", answer: "GUITAR" },
  { clue: "Continent with most countries", answer: "AFRICA" },
  { clue: "Largest mammal", answer: "BLUEWHALE" },
  { clue: "Fastest train in Japan", answer: "SHINKANSEN" },
  { clue: "Language spoken in Brazil", answer: "PORTUGUESE" },
  { clue: "Capital of Australia", answer: "CANBERRA" },
  { clue: "Tallest building in the world", answer: "BURJKHALIFA" },
  { clue: "First element on periodic table", answer: "HYDROGEN" },
  { clue: "Largest island country", answer: "INDONESIA" },
  { clue: "Greek goddess of wisdom", answer: "ATHENA" },
  { clue: "Famous leaning tower city", answer: "PISA" },
  { clue: "River flowing through London", answer: "THAMES" },
  { clue: "Inventor of telephone", answer: "BELL" },
  { clue: "Capital of Italy", answer: "ROME" },
  { clue: "Planet with rings", answer: "SATURN" },
  { clue: "National flower of Japan", answer: "CHERRYBLOSSOM" },
  { clue: "Largest rainforest", answer: "AMAZON" },
  { clue: "Famous scientist with relativity theory", answer: "EINSTEIN" },
  { clue: "Capital of Egypt", answer: "CAIRO" },
  { clue: "Bird symbol of peace", answer: "DOVE" },
  { clue: "Tallest waterfall", answer: "ANGELFALLS" },
  { clue: "Capital of Russia", answer: "MOSCOW" },
  { clue: "Greek god of war", answer: "ARES" },
  { clue: "Largest continent", answer: "ASIA" },
  { clue: "Capital of China", answer: "BEIJING" },
  { clue: "Famous painting by da Vinci", answer: "MONALISA" },
  { clue: "National animal of Australia", answer: "KANGAROO" },
  { clue: "Capital of Germany", answer: "BERLIN" },
  { clue: "Largest coral reef", answer: "GREATBARRIERREEF" },
  { clue: "Capital of Spain", answer: "MADRID" },
  { clue: "Greek god of sun", answer: "APOLLO" },
  { clue: "Capital of Canada", answer: "OTTAWA" },
  { clue: "Famous clock tower in London", answer: "BIGBEN" },
  { clue: "Capital of USA", answer: "WASHINGTON" },

  
  { clue: "Greek god of the underworld", answer: "HADES" },
  { clue: "Author of The Odyssey", answer: "HOMER" },
  { clue: "First woman to win Nobel Prize", answer: "CURIE" },
  { clue: "Largest moon of Saturn", answer: "TITAN" },
  { clue: "Famous battle in 1066", answer: "HASTINGS" },
  { clue: "Language of ancient Rome", answer: "LATIN" },
  { clue: "Shakespeare tragedy with a Moorish general", answer: "OTHELLO" },
  { clue: "River that runs through Baghdad", answer: "TIGRIS" },
  { clue: "Philosopher who wrote Republic", answer: "PLATO" },
  { clue: "First emperor of China", answer: "QINSHIHUANG" },
  { clue: "Greek goddess of love", answer: "APHRODITE" },
  { clue: "Scientist who discovered gravity", answer: "NEWTON" },
  { clue: "Capital of ancient Mesopotamia", answer: "BABYLON" },
  { clue: "Roman god of war", answer: "MARS" },
  { clue: "Epic poem by Virgil", answer: "AENEID" },
  { clue: "Largest moon of Jupiter", answer: "GANYMEDE" },
  { clue: "Philosopher who taught Alexander the Great", answer: "ARISTOTLE" },
  { clue: "Battle where Napoleon was defeated", answer: "WATERLOO" },
  { clue: "Greek god of fire", answer: "HEPHAESTUS" },
  { clue: "Famous library in ancient Egypt", answer: "ALEXANDRIA" },
  { clue: "Roman goddess of wisdom", answer: "MINERVA" },
  { clue: "Famous painting of melting clocks", answer: "PERSISTENCEOFMEMORY" },
  { clue: "Greek god of messengers", answer: "HERMES" },
  { clue: "First man to circumnavigate globe", answer: "MAGELLAN" },
  { clue: "Famous scientist who discovered penicillin", answer: "FLEMING" },
  { clue: "Greek god of wine", answer: "DIONYSUS" },
  { clue: "Roman god of the sea", answer: "NEPTUNE" },
  { clue: "Greek goddess of the hunt", answer: "ARTEMIS" },
  { clue: "Roman goddess of love", answer: "VENUS" },
  { clue: "Philosopher who said 'I think, therefore I am'", answer: "DESCARTES" },
  { clue: "Greek god of time", answer: "CHRONOS" },
  { clue: "Famous scientist who proposed heliocentric theory", answer: "COPERNICUS" },
  { clue: "Greek goddess of harvest", answer: "DEMETER" },
  { clue: "Roman god of the sun", answer: "SOL" },
  { clue: "Greek god punished with holding sky", answer: "ATLAS" },
  { clue: "Roman god of beginnings", answer: "JANUS" },
  { clue: "Greek goddess of victory", answer: "NIKE" },
  { clue: "Roman god of agriculture", answer: "SATURN" },
  { clue: "Greek goddess of discord", answer: "ERIS" },
  { clue: "Roman god of underworld", answer: "PLUTO" },
  { clue: "Greek god of dreams", answer: "MORPHEUS" },
  { clue: "Roman goddess of hearth", answer: "VESTA" },
  { clue: "Greek god of sleep", answer: "HYPNOS" },
  { clue: "Roman god of commerce", answer: "MERCURY" },
  { clue: "Greek goddess of revenge", answer: "NEMESIS" },
  { clue: "Roman goddess of hunting", answer: "DIANA" },
  { clue: "Greek god of healing", answer: "ASCLEPIUS" },
  { clue: "Roman god of love", answer: "CUPID" },
  { clue: "Greek goddess of night", answer: "NYX" },
  { clue: "Roman god of doors and gates", answer: "JANUS" },




  { clue: "A round orange fruit", answer: "ORANGE" },
  { clue: "A small purple fruit", answer: "GRAPE" },
  { clue: "It shines in the sky", answer: "SUN" },
  { clue: "It twinkles at night", answer: "STAR" },
  { clue: "It is used to write on paper", answer: "PENCIL" },
  { clue: "It is used to open doors", answer: "KEY" },
  { clue: "It is used to call people", answer: "PHONE" },
  { clue: "It is used to sit on", answer: "CHAIR" },
  { clue: "It is used to sleep on", answer: "BED" },
  { clue: "It is used to eat soup", answer: "BOWL" },
  { clue: "It is used to drink tea", answer: "CUP" },
  { clue: "It is used to cut food", answer: "KNIFE" },
  { clue: "It is used to cover the floor", answer: "CARPET" },
  { clue: "It is used to keep clothes", answer: "CUPBOARD" },
  { clue: "It is used to keep books", answer: "SHELF" },
  { clue: "It is used to keep food cold", answer: "FRIDGE" },
  { clue: "It is used to cook bread", answer: "OVEN" },
  { clue: "It is used to wash hands", answer: "TAP" },
  { clue: "It is used to clean floor", answer: "MOP" },
  { clue: "It is used to carry books", answer: "BAG" },
  { clue: "It is used to cover head", answer: "HAT" },
  { clue: "It is used to wear on wrist", answer: "BAND" },
  { clue: "It is used to wear on finger", answer: "RING" },
  { clue: "It is used to wear on neck", answer: "NECKLACE" },
  { clue: "It is used to wear on ears", answer: "EARRING" },
  { clue: "It is used to wear on legs", answer: "PANTS" },
  { clue: "It is used to wear on body", answer: "SHIRT" },
  { clue: "It is used to wear on feet", answer: "SOCKS" },
  { clue: "It is used to protect from sun", answer: "UMBRELLA" },
  { clue: "It is used to protect eyes", answer: "SHADES" },
  { clue: "It is used to protect hands", answer: "MITTENS" },
  { clue: "It is used to protect head", answer: "HELMET" },
  { clue: "It is used to protect teeth", answer: "MOUTHGUARD" },
  { clue: "It is used to protect skin", answer: "LOTION" },
  { clue: "It is used to protect from cold", answer: "JACKET" },
  { clue: "It is used to protect from heat", answer: "FAN" },
  { clue: "It is used to protect from rain", answer: "CANOPY" },
  { clue: "It is used to protect from wind", answer: "WINDOW" },
  { clue: "It is used to protect from fire", answer: "EXTINGUISHER" },
  { clue: "It is used to protect from theft", answer: "LOCK" },
  { clue: "It is used to protect from noise", answer: "EARPLUGS" },
  { clue: "It is used to protect from dust", answer: "MASK" },
  { clue: "It is used to protect from germs", answer: "SANITIZER" },
  { clue: "It is used to protect from insects", answer: "NET" },
  { clue: "It is used to protect from light", answer: "CURTAIN" },
  { clue: "It is used to protect from heat in kitchen", answer: "APRONS" },
  { clue: "It is used to protect from scratches", answer: "COVER" },
  { clue: "It is used to protect from water", answer: "PLASTIC" },
  { clue: "It is used to protect from stains", answer: "NAPKIN" },


];

export default function WordBuilder1() {
  // Pick random starting index
  const getRandomIndex = () => Math.floor(Math.random() * questions.length);

  const [currentIndex, setCurrentIndex] = useState(getRandomIndex());
  const [letters, setLetters] = useState(
    shuffle(questions[currentIndex].answer.split(""))
  );
  const [builtWord, setBuiltWord] = useState([]);
  const [message, setMessage] = useState("");
  const [score, setScore] = useState(0);
  const [mode, setMode] = useState("drag"); // "drag" or "quiz"
  const [selected, setSelected] = useState("");

  const correctSound = new Audio("/sounds/correct.mp3");
  const wrongSound = new Audio("/sounds/wrong.wav");
  const winSound = new Audio("/sounds/win.mp3");

  function shuffle(array) {
    return array.sort(() => Math.random() - 0.5);
  }

  const checkWord = (word) => {
    if (word === questions[currentIndex].answer) {
      setMessage("🎉 Correct!");
      setScore(score + 10);
      correctSound.play();
      setTimeout(() => {
        const nextIndex = getRandomIndex(); // always random next
        setCurrentIndex(nextIndex);
        setLetters(shuffle(questions[nextIndex].answer.split("")));
        setBuiltWord([]);
        setSelected("");
        setMessage("");
      }, 1000);
    } else {
      setMessage("❌ Wrong!");
      setScore(score - 5);
      wrongSound.play();
      setTimeout(() => {
        setBuiltWord([]);
        setSelected("");
      }, 1000);
    }
  };

  const handleDrop = (e) => {
    const letter = e.dataTransfer.getData("text");
    const newWord = [...builtWord, letter];
    setBuiltWord(newWord);
    if (newWord.length === questions[currentIndex].answer.length) {
      checkWord(newWord.join(""));
    }
  };

  const handleTap = (letter) => {
    const newWord = [...builtWord, letter];
    setBuiltWord(newWord);
    if (newWord.length === questions[currentIndex].answer.length) {
      checkWord(newWord.join(""));
    }
  };

  const handleQuizSubmit = () => {
    if (!selected) return;
    checkWord(selected);
  };

  return (
    <div className="builder-container">
      <h1>🔤 Word Builder</h1>
      <div className="mode-toggle">
        <button
          onClick={() => setMode("drag")}
          className={mode === "drag" ? "active" : ""}
        >
          Drag & Drop
        </button>
        <button
          onClick={() => setMode("quiz")}
          className={mode === "quiz" ? "active" : ""}
        >
          Quiz Mode
        </button>
      </div>

      <p className="clue">Clue: {questions[currentIndex].clue}</p>

      <p className="status2">{message}</p>
      <p className="score2">⭐ Score: {score}</p>

      {mode === "drag" ? (
        <>
          <div className="letters">
            {letters.map((letter, i) => (
              <div
                key={i}
                className="letter"
                draggable
                onDragStart={(e) => e.dataTransfer.setData("text", letter)}
                onClick={() => handleTap(letter)} // tap fallback
              >
                {letter}
              </div>
            ))}
          </div>
          <div
            className="drop-zone"
            onDragOver={(e) => e.preventDefault()}
            onDrop={handleDrop}
          >
            {builtWord.map((l, i) => (
              <span key={i} className="built-letter">{l}</span>
            ))}
          </div>
        </>
      ) : (
        <>
          <div className="options">
            {[
              questions[currentIndex].answer,
              ...shuffle(["BANANA", "APPLE", "ROCKET"].filter(
                w => w !== questions[currentIndex].answer
              ))
            ].map((opt, i) => (
              <button
                key={i}
                className={`option-btn ${selected === opt ? "selected" : ""}`}
                onClick={() => setSelected(opt)}
              >
                {opt}
              </button>
            ))}
          </div>
          <button className="submit-btn" onClick={handleQuizSubmit}>Submit</button>
        </>
      )}
    </div>
  );
}
